import { createAuthClient } from "better-auth/react";
import {
  adminClient,
  organizationClient,
  usernameClient,
} from "better-auth/client/plugins";
import { ssoClient } from "@better-auth/sso/client";

/**
 * Browser-side better-auth client.
 *
 * No `baseURL` on purpose: the default is `${window.location.origin}/api/auth`,
 * which is exactly where the tenant's own origin exposes the backend — Traefik
 * (and the dev rewrite in `next.config.ts`) strip `/api` and forward `/auth/*`
 * to the backend where better-auth is mounted. Keeping it same-origin means the
 * session cookie is first-party and no CORS preflight is involved.
 *
 * The plugins mirror the server (`organization`, `admin`, `username`, `sso`) so
 * their client methods (membership, user admin, `signIn.sso`) are typed and
 * available where needed.
 */
export const authClient = createAuthClient({
  plugins: [
    organizationClient(),
    adminClient(),
    usernameClient(),
    ssoClient(),
  ],
});

export const { signIn, signOut, useSession } = authClient;
